class SimpleQuickAdd extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.dialog = this.querySelector('[data-simple-quick-add-dialog]');
    this.variantSelect = this.querySelector('[data-simple-quick-add-variant]');
    this.variantInput = this.querySelector('input[name="id"]');
    this.submitButton = this.querySelector('.simple-quick-add__submit');

    this.addEventListener('click', this.handleClick);
    this.variantSelect?.addEventListener('change', this.handleVariantChange);
    this.dialog?.addEventListener('click', this.handleDialogClick);
    this.dialog?.addEventListener('close', this.handleDialogClose);
    this.addEventListener('shopify:cart:lines-update', this.handleCartUpdate);

    this.syncVariant();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.variantSelect?.removeEventListener('change', this.handleVariantChange);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.dialog?.removeEventListener('close', this.handleDialogClose);
    this.removeEventListener('shopify:cart:lines-update', this.handleCartUpdate);
    this.setCardNavigation(false);
  }

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('[data-simple-quick-add-open]')) {
      event.preventDefault();
      this.openDialog();
      return;
    }

    if (event.target.closest('[data-simple-quick-add-close]')) {
      event.preventDefault();
      this.closeDialog();
    }
  };

  handleDialogClick = (event) => {
    if (event.target === this.dialog) {
      event.stopPropagation();
      this.closeDialog();
    }
  };

  handleDialogClose = () => {
    this.setCardNavigation(false);
  };

  handleVariantChange = () => {
    this.syncVariant();
  };

  syncVariant() {
    if (!(this.variantSelect instanceof HTMLSelectElement) || !(this.variantInput instanceof HTMLInputElement)) return;

    const selectedOption = this.variantSelect.options[this.variantSelect.selectedIndex];
    if (!selectedOption) return;

    this.variantInput.value = selectedOption.value;
    this.variantInput.disabled = selectedOption.dataset.available !== 'true';

    if (this.submitButton instanceof HTMLButtonElement) {
      this.submitButton.disabled = selectedOption.dataset.available !== 'true';
    }
  }

  openDialog() {
    if (!(this.dialog instanceof HTMLDialogElement)) return;

    this.setCardNavigation(true);

    if (typeof this.dialog.showModal === 'function') {
      if (!this.dialog.open) this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    requestAnimationFrame(() => this.variantSelect?.focus());
  }

  closeDialog() {
    if (!(this.dialog instanceof HTMLDialogElement)) return;

    this.setCardNavigation(false);

    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
  }


  setCardNavigation(disabled) {
    const productCard = this.closest('product-card');
    if (!productCard) return;

    productCard.toggleAttribute('data-no-navigation', disabled);
  }

  handleCartUpdate = (event) => {
    const promise = event.promise;
    if (!promise || typeof promise.then !== 'function') return;

    promise
      .then(({ detail }) => {
        if (detail?.didError) return;

        const submitButton = this.querySelector('[data-quick-add-feedback="true"]');
        const closeDelay = submitButton ? 2200 : 0;
        window.setTimeout(() => this.closeDialog(), closeDelay);
      })
      .catch(() => {});
  };
}

if (!customElements.get('simple-quick-add')) {
  customElements.define('simple-quick-add', SimpleQuickAdd);
}
